<template>
	<v-dialog transition="scroll-x-reverse-transition" max-width="800">
		<template #activator="{ on, attrs }">
			<v-btn
				color="warning"
				dark
				rounded
				elevation="0"
				class="font-weight-bold"
				v-bind="attrs"
				v-on="on">
				<v-icon left>mdi-account-plus-outline</v-icon>
				New User
			</v-btn>
		</template>
		<template #default="dialog">
			<user-form @success="dialog.value = false" @cancel="dialog.value = false" />
		</template>
	</v-dialog>
</template>
<script>
import Backend from '@/Layouts/Backend'
import UserForm from './Form'

export default {
	components: { UserForm },
	layout: Backend,
	props: {
		//
	},
	data () {
		return {
			types: []
		}
	},
	mounted () {
		//
	},
	methods: {
		//
	}
}
</script>
